import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import { hideDevLogs, isProd } from "config/constant";
import logger from "redux-logger";
import arbitraryApi from "../services/arbitraryApi";
import bankApi from "../services/bankApi";
import p2pApi from "../services/p2pApi";
import rateApi from "../services/rateApi";
import swapApi from "../services/swapApi";
import billsApi from "../services/billsApi";
import cardsApi from "../services/cardsApi";
import walletApi from "../services/walletApi";
import chartApi from "../services/chartApi";
import { AccountVerificationReducer } from "./slices/accountVerification.slice";
import { AuthReducer } from "./slices/auth.slice";
import NotificationReducer from "./slices/notification.slice";
import { ProfileReducer } from "./slices/profile.slice";
import { TradeReducer } from "./slices/trade.slice";

import rtkQueryErrorHandler from "./middlewares/errorHandler";

const devMiddlewares = isProd ? [] : [logger];

const store = configureStore({
  reducer: {
    profile: ProfileReducer,
    trade: TradeReducer,
    [swapApi.reducerPath]: swapApi.reducer,
    [rateApi.reducerPath]: rateApi.reducer,
    [bankApi.reducerPath]: bankApi.reducer,
    [chartApi.reducerPath]: chartApi.reducer,
    [p2pApi.reducerPath]: p2pApi.reducer,
    [billsApi.reducerPath]: billsApi.reducer,
    [cardsApi.reducerPath]: cardsApi.reducer,
    [walletApi.reducerPath]: walletApi.reducer,
    [arbitraryApi.reducerPath]: arbitraryApi.reducer,
    accountVerification: AccountVerificationReducer,
    auth: AuthReducer,
    notifications: NotificationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat([
      ...devMiddlewares,
      rtkQueryErrorHandler,
      bankApi.middleware,
      chartApi.middleware,
      p2pApi.middleware,
      rateApi.middleware,
      swapApi.middleware,
      billsApi.middleware,
      cardsApi.middleware,
      walletApi.middleware,
      arbitraryApi.middleware,
    ]),
  devTools: !isProd && !hideDevLogs,
});

setupListeners(store.dispatch);

export default store;
